import { useCallback, useRef, useState } from 'react';

/**
 * this function increments the page number as the user scrolls the lastElementRef into view
 * @see https://github.com/vimeows/vimeo/blob/48a5e4972eb7b168f8e22429d2601c3445f27f42/frontend/libs/comments-view/src/hooks/use-infinite-scroll.ts
 */
export function useInfiniteScroll(canLoadMore: boolean, initialPage?: number) {
  const [page, setPage] = useState(initialPage || 1);

  let bottomObserver = useRef<IntersectionObserver | null>(null);

  const lastElementRef = useCallback(
    (node: HTMLDivElement) => {
      if (!canLoadMore) {
        return;
      }
      if (bottomObserver.current) {
        bottomObserver.current.disconnect();
      }
      bottomObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && canLoadMore) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) bottomObserver.current.observe(node);
    },
    [canLoadMore],
  );

  return [page, lastElementRef, setPage] as const;
}
